import { QueryEntity } from '@datorama/akita';
import { State, AppStore } from './app.store';
import { AppState } from './app.model';
​
export class AppQuery extends QueryEntity<State, AppState> {
  constructor(protected store: AppStore) {
    super(store);
  }
}
